export default __webpack_public_path__ + "static/media/icon-werbefilm.195a6ac4.svg";